import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../Store";
import { asyncReqCommunityBoardList, CommunityBoardListActions } from "../../reducers/CommunityBoardListReducer";
import CommonUtil from "../../utils/CommonUtil";

const SearchForm = () => {

    const dispatch = useDispatch<AppDispatch>();

    const refInputValSearchType = useRef<HTMLSelectElement>(null); // 검색 조건 선택박스 참조 객체
    const refInputValSearchKeyword = useRef<HTMLInputElement>(null); // 검색 키워드 입력박스 참조 객체
    const [inputValSearchType, setInputValSearchType] = useState(""); // 검색 조건 입력 값 참조 객체
    const [inputValSearchKeyword, setInputValSearchKeyword] = useState(""); // 검색 키워드 입력 값 참조 객체
    const refBtnSearch = useRef<HTMLAnchorElement>(null); // 검색 링크 버튼 참조 객체

    const searchType = CommonUtil.getQuerystring("search_type", "");
    const searchKeyword = CommonUtil.getQuerystring("search_keyword", "");

    useEffect(() => {
        setInputValSearchType(searchType);
        setInputValSearchKeyword(searchKeyword);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchType, searchKeyword]);
    
    /**
    * 검색어 입력박스 change 이벤트
    * 
    * @param {React.ChangeEvent<HTMLSelectElement | HTMLInputElement>} e 이벤트 객체
    * @returns {void}
    */
    const handlerInputValSearch = (e: React.ChangeEvent<HTMLSelectElement | HTMLInputElement>): void => {
        
        if (e.target instanceof HTMLSelectElement) setInputValSearchType(e.target.value);
        else if (e.target instanceof HTMLInputElement) setInputValSearchKeyword(e.target.value);
    }
    
    /**
    * 입력창 엔터 키 체크 이벤트
    * 
    * @param e 이벤트 객체
    * @returns 
    */
    const handlerInputEnterProc = (e: React.KeyboardEvent<HTMLInputElement>) => {

        const btnEl: HTMLAnchorElement | null = refBtnSearch.current;
        if (e.key === "Enter") {
            $(e.target).trigger("blur");
            btnEl?.click();
        }
    }

    /**
    * 검색 버튼 클릭 이벤트 
    * 
    * @param {React.MouseEvent<HTMLAnchorElement, MouseEvent>} e 이벤트 객체
    * @returns {void}
    */
    const handlerSearchStart = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>): void => {
        e.preventDefault();

        const selEl: HTMLSelectElement | null = refInputValSearchType.current;
        if (selEl === null) return;

        const iptEl: HTMLInputElement | null = refInputValSearchKeyword.current;
        if (iptEl === null) return;

        let query_string = (selEl.value === "" ? "" : "&search_type=" + encodeURIComponent(selEl.value))
            + (iptEl.value === "" ? "" : "&search_keyword=" + encodeURIComponent(iptEl.value))
            ;
        if (query_string !== "") query_string = "?" + query_string.substring(1);

        const url: string = "/community_board_list" + query_string;
        (window as any).urlChange(url);
        
        // 게시물 목록 가져오기
        const page_size = parseInt(process.env.REACT_APP_COMMUNITY_BOARD_PAGE_SIZE as string, 10);
        const curr_page = 1;
        const search_type = selEl.value;
        const search_keyword = iptEl.value;
        const sub_menu = "";
        dispatch(asyncReqCommunityBoardList({ page_size, curr_page, search_type, search_keyword, sub_menu }));
        dispatch(CommunityBoardListActions.setCurrPage(curr_page)); // 현재 페이지 번호 저장
    }

    return (
        <fieldset className="bo_sch">
            <select id="sel_find_filed" ref={refInputValSearchType} onChange={handlerInputValSearch} value={inputValSearchType}>
                <option value="UCBM_TITLE">제목</option>                
                <option value="UCBM_CONTENT">내용</option>
                <option value="UCBM_TITLE,UCBM_CONTENT">제목+내용</option>
               
            </select>
            <div className="sch_area">
                <input type="text" id="input_find_value" className="stx sch_input" size={25} maxLength={20} placeholder="검색어를 입력하세요" autoComplete="off" ref={refInputValSearchKeyword} onChange={handlerInputValSearch} onKeyDown={handlerInputEnterProc} value={inputValSearchKeyword} />
                <input type="text" style={{display: "none"}} />
                <span className="btn" style={{marginLeft: "-15px", paddingTop: "3px", verticalAlign: "middle", display: "inline-block"}}><a href="#!" onClick={handlerSearchStart} ref={refBtnSearch} aria-label="검색"><i className="fa fa-search fa-2x" aria-hidden="true"></i></a></span>
            </div>
        </fieldset>
    )
}

export default SearchForm;
